<template>
  <div id="zt8351">
    <div id="z1">
      <div>{{$store.state.iscn?'ZT8351税控产品':'ZT8351 Fiscal Product  '}}</div>
      <label>{{$store.state.iscn?'标准铅封装置设计，具备金融设备级别的拆机监测机制':'Security sealing & tamper-proof design'}} </label>
    </div>
    <div id="z2">
      <label v-if="$store.state.iscn">ZT8351是新一代小型智能税控终端，内置128MB超大容量安全税控模块和硬件加密模块支持3DES、ECC、RSA等国际标准加密算法，可实现财务代码计算，发票电子化管理和安全存储功能。</label>
      <label v-else>Large-capacity fiscal module inside Built-in hardware encryption module <br/>Support multiple encryption algorithms</label>
    </div>
    <div id="z3">
      <div>{{$store.state.iscn?'大容量安全存储':'Large memory'}}</div>
      <label>{{$store.state.iscn?'内置128MB超大容量安全税控模块':'Built-in 128M fiscal module'}}</label>
    </div>
    <div id="z4">
      <div>{{$store.state.iscn?'通讯多样':'Multiple & Stable network'}}</div>
      <label>{{$store.state.iscn?'具备2G/3G/4G无线、以太网通讯方式，支持双IP通讯共存':'WIFI + 2G/3G/4G and Ethernet, supporti dual IP communication coexistence'}}</label>
    </div>
    <pdspecs :data="$store.state.iscn?spdata:spdata_en"></pdspecs>
  </div>
</template>

<script>
import pdspecs from '@/components/pdspecs'
export default {
  name: '',
  components: {
    pdspecs
  },
  props: {
    data: Object
  },
  watch: {
    
  },
  data () {
    return {
      spdata: {
        file: 'ZT8351',
        data: [
          {label: '处理器', desc: ['ARM四核1.1GHz高速处理器','32位高性能安全处理器'],pic: 'cpu.png'},
          {label: '存储器', desc: ['1GB RAM+8GB ROM','2GB RAM+16GB ROM（可选）','支持MicrosSD扩展，最大32GB'],pic: 'ram.png'},
          {label: '操作系统', desc: ['Android 5.1 / 7.1','证通安全操作系统（ZOS）'], pic: 'sys.png'},
          {label: '屏幕', desc: ['132x32 点阵显示屏'], pic: 'disp.png'},
          {label: '税控模块', desc: ['128MB加密存储','支持3DES、AES、RSA、SHA-256等算法'], pic: 'tax.png'},
          {label: '移动网络', desc: ['支持 GSM / WCDMA / EVDO / TD-SCDMA /  TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['支持IEEE 802.11 b /g/ n,2.4GHz'], pic: 'wifi.png'},
          {label: '蓝牙', desc: ['支持蓝牙 4.0及以上','支持BLE'], pic: 'blt.png'},
          {label: '定位', desc: ['内置GPS / 北斗 / Glonass','支持LBS功能','支持AGPS'], pic: 'lbs.png'},
          {label: '扬声器', desc: ['内置扬声器，功率0.5W','声压82dB±3dB'], pic: 'speaker.png'},
          {label: '接口', desc: ['USB host×1、 Micro USB×1、RJ45×1、PSAM×1'], pic: 'port.png'},
          {label: '按键', desc: ['电源键×1'], pic: 'keyt.png'},
          {label: '指示灯', desc: ['充电指示灯x1','电源指示灯x1'], pic: 'lamp.png'},
          {label: '电池', desc: ['锂电池 3.7V/5000mAh'], pic: 'battery.png'},
          {label: '适配器', desc: ['输入：AC 100~240V','输出：DC 5V/2A'], pic: 'char.png'},
          {label: '尺寸（长×宽×高）', desc: ['130mm×100mm×28.9mm'], pic: 'size.png'},
          {label: '适用环境', desc: ['工作温度： 0℃～+50℃ ','存储温度：-20℃～+70℃','相对湿度：10%～90% RH (不结露)'], pic: 'env.png'}
        ]
      },
      spdata_en: {
        file: 'ZT8351',
        data: [
          {label: 'Processor', desc: ['Quad core@1.1GHz'],pic: 'cpu.png'},
          {label: 'Memory', desc: ['1GB RAM+8GB ROM','2GB RAM+16GB ROM（Optional）','MicroSD x1 support up to 32 GB'],pic: 'ram.png'},
          {label: 'OS', desc: ['ZOS based on Android 5.1/7.1'], pic: 'sys.png'},
          {label: 'Display', desc: ['132 x32 dot matrix'], pic: 'disp.png'},
          {label: 'Fiscal Module', desc: ['128M encrypted storage','3DES,AES, RSA,SHA-256,etc.'], pic: 'tax1.png'},
          {label: 'Cellular Network', desc: ['GSM / WCDMA / EVDO / TD-SCDMA /  TDD-LTE / FDD-LTE'], pic: 'mobi.png'},
          {label: 'WIFI', desc: ['IEEE 802.11 b /g/ n', '2.4GHz'], pic: 'wifi.png'},
          {label: 'Bluetooth', desc: ['Bluetooth 4.0 and above','BLE'], pic: 'blt.png'},
          {label: 'Location', desc: ['Built-in GPS/Beidou/Glonass','LBS','AGPS'], pic: 'lbs.png'},
          {label: 'Printer', desc: ['58mm thermal printer','40mm roll paper'], pic: 'prt.png'},
          {label: 'Speaker', desc: ['Built-in speaker, 0.5W','82dB±3dB'], pic: 'speaker.png'},
          {label: 'Port', desc: ['USB ×1、Micro USB x1', 'RJ45 Ethernet x1、PSAMx1'], pic: 'port.png'},
          {label: 'Keypad', desc: ['Power x1'], pic: 'keyt.png'},
          {label: 'Indicator', desc: ['Charging ×1、power x 1', 'Network x 1、user-defined x1'], pic: 'lamp.png'},
          {label: 'Battery', desc: ['Lithium battery 3.7V/2550mAH'], pic: 'battery.png'},
          {label: 'Adapter', desc: ['Input: AC110-240V', 'Output: DC 5v/4A'], pic: 'char.png'},
          {label: 'Dimension(LxWxH)', desc: ['130mm x 100mm x28.9mm'], pic: 'size.png'},
          {label: 'Environment', desc: ['Working temp: 0℃~+50℃', 'Storage temp: -20°℃~+70°℃', 'Relative humidity : 10%~90%RH(non-condensing)'], pic: 'env.png'}
        ]
      }
    }
  },
  methods: {
  
  },
  mounted () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#zt8351 {
  background: white;
  margin-top: -.93rem;
}
#z1 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8351/bg1.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.88rem;
  color: white;
}
#z1 div {
  margin-top: 3.62rem;
  font-size: .6rem;
  font-weight: bold;
}
#z1 label {
  display: block;
  margin-top: .35rem; 
  font-size: .4rem;
  font-weight: 400;
  margin-left: .03rem;
  font-size: .24rem;
}
#z1 img {
  width: 4.9rem;
}
#z2 {
  height: 1.78rem;
  background: #111111;
  text-align: center;
}
#z2 label {
  display: inline-block;
  width: 12.2rem;
  font-size: .24rem;
  font-weight: 400;
  color: #FFFFFF;
  margin-top: .45rem;
  line-height: .48rem;
}

#z3 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8351/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 11.73rem;
  color: white;
}
#z3 div {
  margin: 3.12rem 0 .2rem 0;
  font-size: .56rem;
  font-weight: bold;
}
#z3 label {
  margin-left: .05rem;
  width: 5.4rem;
  display: block;
  font-size: .24rem;
  font-weight: 400;
}

#z4 {
  height: 9rem;
  background-image: url('../../assets/pic/zt8351/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
  padding-left: 3.6rem;
  color: white;
}
#z4 div {
  margin: 3rem 0 .2rem 0;
  font-size: .55rem;
  font-weight: 800;
}
#z4 label {
  margin-left: .05rem;
  width: 5.29rem;
  display: block;
  font-size: .3rem;
  font-weight: 500;
}
</style>
